import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('NotificationManager', null, {
    withChildren: true,
});
